// TODO: Refactor. Move app state to store. Separate components
import { FC, lazy, useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';

import { route_path } from '@app/utils/route_path';
import { COOKIE_KEY, cookieUtils } from '@app/app/cookie';
import { RegisterQuizFullWidth } from '@app/widgets/register-quiz/ui/register-quiz-full';
import { queryClient } from '@app/app/lib/queryClient';

const CookiePopup = lazy(() => import('@app/common/cookiePopup.js'));
const PaymentCancelNotify = lazy(() => import('@app/modals/paymentCancelNotify.js'));
const PaymentSuccessNotify = lazy(() => import('@app/modals/paymentSuccessNotify.js'));

const PaymentErrorNotify: FC<{ close: () => void }> = ({ close }) => {
  return (
    <div className="modal">
      <div className="modal_overlay" onClick={close}></div>
      <div className="modal_window">
        <div className="modal_close" onClick={close}>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <line
              y1="-1"
              x2="21.2624"
              y2="-1"
              transform="matrix(0.706015 0.708197 -0.706015 0.708197 1 2.35706)"
              stroke="black"
              strokeWidth="2"
            />
            <line
              y1="-1"
              x2="21.2624"
              y2="-1"
              transform="matrix(-0.706015 0.708197 0.706015 0.708197 16.7895 2.35706)"
              stroke="black"
              strokeWidth="2"
            />
          </svg>
        </div>
        <div className="modal_msg">
          Something went wrong during payment.
          <br />
          Please repeat or write to our technical support.
        </div>
      </div>
    </div>
  );
};

export function RootLayout() {
  const location = useLocation();

  const [showCookiePopup, setShowCookiePopup] = useState(
    !cookieUtils.get(COOKIE_KEY.cookieAccepted),
  );
  const [showQuiz, setShowQuiz] = useState(!!cookieUtils.get(COOKIE_KEY.showQuiz));
  const [showPaymentSuccessNotify, setShowPaymentSuccessNotify] = useState(false);
  const [showPaymentErrorNotify, setShowPaymentErrorNotify] = useState(false);
  const [showPaymentCancelNotify, setShowPaymentCancelNotify] = useState(false);
  const [paymentCancelNotifyBackUrl, setPaymentCancelNotifyBackUrl] = useState(route_path.pricing);

  useEffect(() => {
    if (window.location.search.includes('success')) {
      setShowPaymentSuccessNotify(true);
      window.history.replaceState(
        {},
        document.title,
        window.location.href.replace(/(\?|&)+success/, ''),
      );
    } else if (window.location.search.includes('error')) {
      setShowPaymentErrorNotify(true);
      window.history.replaceState(
        {},
        document.title,
        window.location.href.replace(/(\?|&)+error/, ''),
      );
    } else {
      if (window.location.search.includes('cancel')) {
        setShowPaymentCancelNotify(true);
        window.history.replaceState(
          {},
          document.title,
          window.location.href.replace(/(\?|&)+cancel/, ''),
        );
      }

      const gotoProduct = window.sessionStorage.getItem('gotoProduct');
      if (gotoProduct) {
        setShowPaymentCancelNotify(true);
        const parsed = JSON.parse(gotoProduct);
        setPaymentCancelNotifyBackUrl(parsed.url);
      }
    }
    window.sessionStorage.removeItem('gotoProduct');
  }, []);

  useEffect(() => {
    if (window.location.search.includes('success')) {
      setShowPaymentSuccessNotify(true);
      window.history.replaceState(
        {},
        document.title,
        window.location.href.replace(/(\?|&)+success/, ''),
      );
    } else if (window.location.search.includes('error')) {
      setShowPaymentErrorNotify(true);
      window.history.replaceState(
        {},
        document.title,
        window.location.href.replace(/(\?|&)+error/, ''),
      );
    } else {
      if (window.location.search.includes('cancel')) {
        setShowPaymentCancelNotify(true);
        window.history.replaceState(
          {},
          document.title,
          window.location.href.replace(/(\?|&)+cancel/, ''),
        );
      }

      const gotoProduct = window.sessionStorage.getItem('gotoProduct');
      if (gotoProduct) {
        setShowPaymentCancelNotify(true);
        const parsed = JSON.parse(gotoProduct);
        setPaymentCancelNotifyBackUrl(parsed.url);
      }
    }
    window.sessionStorage.removeItem('gotoProduct');
  }, []);

  useEffect(() => {
    // Scroll to top
    window.scrollTo(0, 0);

    // Handle meta viewport logic
    const pathname = location.pathname;
    if (window.innerWidth <= 1024) {
      const viewportMeta = document.querySelector('meta[name="viewport"]');
      const isFixed = pathname.match(/\/create|files|\/workspace/);

      viewportMeta?.setAttribute(
        'content',
        isFixed ? 'width=1024' : 'width=device-width, initial-scale=1',
      );
    }

    // Session cleanup
    if (!pathname.match(/\/create\//)) {
      sessionStorage.removeItem('genState');
    }
    if (!pathname.match(/\/create-draft\//)) {
      sessionStorage.removeItem('draftState');
    }
  }, [location.pathname, location.search]);

  return (
    <QueryClientProvider client={queryClient}>
      <Outlet />
      {showCookiePopup && <CookiePopup close={() => setShowCookiePopup(false)} />}

      {showPaymentSuccessNotify && (
        <PaymentSuccessNotify close={() => setShowPaymentSuccessNotify(false)} />
      )}

      {showPaymentErrorNotify && (
        <PaymentErrorNotify close={() => setShowPaymentErrorNotify(false)} />
      )}

      {showPaymentCancelNotify && (
        <PaymentCancelNotify
          close={() => setShowPaymentCancelNotify(false)}
          backUrl={paymentCancelNotifyBackUrl}
        />
      )}
      {showQuiz && <RegisterQuizFullWidth onClose={() => setShowQuiz(false)} />}
    </QueryClientProvider>
  );
}
